import { LineType } from "./LineRegionChart";

export function getGraphTypeColors(
  graphType: LineType,
  isContralateral: boolean
) {
  let borderColor,
    backgroundColor,
    pointColor,
    pointBorderColor,
    pointHoverBackgroundColor,
    pointHoverBorderColor;

  if (isContralateral) {
    if (graphType === LineType.Extension) {
      borderColor = "#FF9549";
      backgroundColor = "#FFE8D8";
      pointColor = "#FFE8D8";
      pointBorderColor = "#FF9549";
      pointHoverBackgroundColor = "#FF9549";
      pointHoverBorderColor = "#FF9549";
    } else {
      borderColor = "#05B2DC";
      backgroundColor = "#A7E3F2";
      pointColor = "#A7E3F2";
      pointBorderColor = "#05B2DC";
      pointHoverBackgroundColor = "#A7E3F2";
      pointHoverBorderColor = "#05B2DC";
    }
  } else {
    if (graphType === LineType.Extension) {
      borderColor = "#A56BB3";
      backgroundColor = "#E3B7EE";
      pointColor = "#E3B7EE";
      pointBorderColor = "#A56BB3";
      pointHoverBackgroundColor = "#E3B7EE";
      pointHoverBorderColor = "#A56BB3";
    } else {
      borderColor = "#C83D57";
      backgroundColor = "#FCB4C1";
      pointColor = "#FCB4C1";
      pointBorderColor = "#C83D57";
      pointHoverBackgroundColor = "#FCB4C1";
      pointHoverBorderColor = "#C83D57";
    }
  }

  return {
    borderColor,
    backgroundColor,
    pointColor,
    pointBorderColor,
    pointHoverBackgroundColor,
    pointHoverBorderColor,
    borderWidth: 2,
  };
}
